import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ChevronLeft, ChevronRight, Flame } from 'lucide-react';
import { sectionHook } from '../../lib/domHooks';

/**
 * Herkül şemasının bölüm kabuğu.
 *
 * Referans arayüzde başlık solda (renkli kare içinde ikon + başlık + alt
 * başlık), sağda "Tümünü Gör (N) →" düğmesi ve şeridi kaydıran ok çifti
 * durur; altında yatay kayan kart şeridi.
 *
 * İkon bölüm başına verilir: her şeridin başında aynı alev ikonunu çizmek
 * bölümleri birbirinden ayırt edilemez yapıyordu.
 */
const HerkulSection = ({
  title, subtitle, to, icon: Icon = Flame, tone = 'gold',
  count = null, shown = 0, wide = false, section, children,
}) => {
  const stripRef = useRef(null);

  const scroll = (direction) => {
    const el = stripRef.current;
    if (!el) return;
    el.scrollBy({ left: direction * Math.max(el.clientWidth * 0.8, 240), behavior: 'smooth' });
  };

  const total = Number.isFinite(count) && count > 0 ? count : 0;
  const seeAllLabel = total > shown ? `Tümünü Gör (${total})` : 'Tümünü Gör';

  return (
    <section className="herkul-section" {...sectionHook(section)}>
      <div className="herkul-section-head">
        <div className="herkul-section-title-wrap">
          <span className={`herkul-section-icon is-${tone}`}><Icon size={17} /></span>
          <div className="herkul-section-heading">
            <h2 className="herkul-section-title">{title}</h2>
            {subtitle && <p className="herkul-section-sub">{subtitle}</p>}
          </div>
        </div>
        <div className="herkul-section-nav">
          {to && (
            // Etiket iki biçimde birden yazılır: dar ekranda "Tümünü Gör
            // (1240)" başlığı taşırıyor, sayıyı JS ile kırpmak ise yeniden
            // boyutlandırmada yeniden çizim isterdi — hangisinin görüneceğine
            // CSS karar verir.
            <Link to={to} className="herkul-section-more">
              <span className="herkul-section-more-long">{seeAllLabel}</span>
              <span className="herkul-section-more-short">Tümü</span>
              <ArrowRight size={14} />
            </Link>
          )}
          <button
            type="button"
            className="herkul-nav-arrow"
            onClick={() => scroll(-1)}
            aria-label="Önceki"
          >
            <ChevronLeft size={16} />
          </button>
          <button
            type="button"
            className="herkul-nav-arrow"
            onClick={() => scroll(1)}
            aria-label="Sonraki"
          >
            <ChevronRight size={16} />
          </button>
        </div>
      </div>
      <div className={`herkul-strip ${wide ? 'is-wide' : ''}`} ref={stripRef}>
        {children}
      </div>
    </section>
  );
};

export default HerkulSection;
